import { render } from "./WCCreateListModal.vue?vue&type=template&id=07ca22ac"
import script from "./WCCreateListModal.vue?vue&type=script&lang=js"
export * from "./WCCreateListModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__